import { FC, useCallback, useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import Button from 'components/Button';
import Error from 'components/form/Error';
import privateAPI from 'utils/privateAxiosInstance';
import { DefaultLoader, LoaderContainer } from 'components/Loader';
import CopyText from 'components/CopyText';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 25vh;
  width: 100%;
  align-items: center;
  justify-content: center;
  h1 {
    font-size: 1.5rem;
    font-weight: 500;
    margin-bottom: 1rem;
  }
  p {
    text-align: center;
  }

  button {
    margin-top: 1rem;
    margin-bottom: 0.5rem;
  }
`;

const VerifyEmail: FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [failed, setFailed] = useState<boolean>(false);
  const [verified, setVerified] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);

  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const handleVerify = useCallback(() => {
    setLoading(true);
    setError(false);

    privateAPI
      .post('/auth/verify-email', {
        indent: searchParams.get('indent'),
        token: searchParams.get('token'),
      })
      .then(() => {
        setLoading(false);
        setVerified(true);
        setError(false);
        const next = searchParams.get('next');
        setTimeout(() => navigate(next || '/'), 3000);
      })
      .catch(() => {
        setTimeout(() => {
          setFailed(true);
          setLoading(false);
          setError(true);
        }, 3000);
      });
  }, [navigate, searchParams]);

  useEffect(() => handleVerify(), [handleVerify]);
  return (
    <Container>
      {!verified ? (
        failed ? (
          <>
            <h1>Activation du compte</h1>
            <p>La validation de votre adresse email à échoué.</p>
            <p>
              Vous pouvez réessayer de valider votre adresse email en cliquant
              sur le bouton ci-dessous.
            </p>
            <Button
              color="primary"
              variant="filled"
              loading={loading}
              onClick={handleVerify}
            >
              Valider mon adresse email
            </Button>
            {error && <Error>Une erreur est survenue.</Error>}
            <p style={{ marginTop: '2rem' }}>
              Si l'erreur persiste, veuillez réessayer ultérieurement ou nous
              contacter à l'adresse suivante:
            </p>
            <CopyText text="mentorat@engagement.fr" />
          </>
        ) : (
          <LoaderContainer>
            <DefaultLoader size={1.5} />
          </LoaderContainer>
        )
      ) : (
        <p>Votre compte a été activé, vous allez être redirigé...</p>
      )}
    </Container>
  );
};

export default VerifyEmail;
